import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Target, Eye, Heart, CheckCircle2, GraduationCap, Briefcase, TrendingUp, Recycle, Award } from 'lucide-react';
export function AboutPage() {
  return <Layout data-id="element-120">
      <SEO {...pageSEO.about} data-id="element-121" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-122">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-123">
          <h1 className="text-4xl font-bold mb-4" data-id="element-124">À Propos de l'ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-125">
            Une approche complète : de la montée en compétences à l'emploi digne
          </p>
        </div>
      </div>

      {/* Notre Approche */}
      <section className="py-20 bg-white" data-id="element-126">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
          <div className="text-center mb-12" data-id="element-128">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-129">
              Notre Approche
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-130">
              Une chaîne de valeur complète
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-131">
              L'ADCC développe une chaîne de valeur complète pour garantir un
              impact réel, mesurable et durable.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12" data-id="element-132">
            {[{
            icon: GraduationCap,
            title: 'Développer',
            desc: 'Acquisition de compétences techniques et humaines',
            color: 'bg-blue-50'
          }, {
            icon: Award,
            title: 'Tester',
            desc: 'Validation des acquis et professionnalisation',
            color: 'bg-green-50'
          }, {
            icon: Briefcase,
            title: 'Insérer',
            desc: "Mise en relation avec des opportunités d'emploi",
            color: 'bg-purple-50'
          }, {
            icon: TrendingUp,
            title: 'Suivre',
            desc: 'Accompagnement post-placement et amélioration continue',
            color: 'bg-amber-50'
          }, {
            icon: Recycle,
            title: 'Recycler',
            desc: 'Reconversion et mise à jour des compétences',
            color: 'bg-teal-50'
          }].map((step, index) => <Card key={index} className="text-center h-full" data-id="element-133">
                <CardContent className="pt-6 pb-4" data-id="element-134">
                  <div className={`inline-flex items-center justify-center p-3 ${step.color} rounded-full mb-3`} data-id="element-135">
                    <step.icon className="w-7 h-7 text-[#1E88E5]" data-id="element-136" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-137">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-138">{step.desc}</p>
                </CardContent>
              </Card>)}
          </div>

          <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] text-white rounded-2xl p-8 md:p-12" data-id="element-139">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-140">
              Nos objectifs 2026
            </h3>
            <p className="text-lg text-blue-100 mb-8" data-id="element-141">
              L'ADCC se fixe des objectifs ambitieux pour l'année 2026, avec une
              vision claire de l'impact que nous souhaitons avoir sur les
              communautés que nous servons.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-142">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-143">
                <p className="text-3xl font-bold mb-2" data-id="element-144">100</p>
                <p className="text-sm text-blue-100" data-id="element-145">
                  Personnes à accompagner en 2026
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-146">
                <p className="text-3xl font-bold mb-2" data-id="element-147">60%</p>
                <p className="text-sm text-blue-100" data-id="element-148">
                  Taux de placement envisagé en 2026
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-149">
                <p className="text-3xl font-bold mb-2" data-id="element-150">100%</p>
                <p className="text-sm text-blue-100" data-id="element-151">
                  D'insertion éthique et transparente en 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Engagement */}
      <section className="py-20 bg-gray-50" data-id="element-152">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-154">
            <div data-id="element-155">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-156">
                Notre Engagement Éthique
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-157">
                Une insertion responsable et digne
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-158">
                Nous œuvrons pour une insertion responsable, fondée sur des
                valeurs fortes et un cadre éthique rigoureux.
              </p>
              <div className="space-y-4" data-id="element-159">
                {[{
                title: 'La dignité du travail',
                desc: 'Respect des droits et de la personne dans toutes les relations professionnelles'
              }, {
                title: 'La transparence des conditions',
                desc: "Clarté sur les conditions d'emploi, rémunération et responsabilités"
              }, {
                title: 'Le respect des personnes',
                desc: 'Valorisation de chaque individu et de son parcours professionnel'
              }, {
                title: 'La valorisation des compétences acquises',
                desc: 'Reconnaissance et mise en valeur des formations certifiantes'
              }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm" data-id="element-160">
                    <CheckCircle2 className="w-6 h-6 text-[#1E88E5] flex-shrink-0 mt-1" data-id="element-161" />
                    <div data-id="element-162">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-163">
                        {item.title}
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-164">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>
            <div data-id="element-165">
              <img src="https://cdn.magicpatterns.com/uploads/jfY9WFQQPLNmCKBmbcpuEW/Femmes_Menage_Emploi_3.png" alt="Formation et certification ADCC" className="rounded-2xl shadow-xl w-full" data-id="element-166" />
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white" data-id="element-167">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-169">
            <div className="order-2 lg:order-1" data-id="element-170">
              <div className="bg-gradient-to-br from-blue-50 to-gray-100 rounded-2xl p-12 flex items-center justify-center" data-id="element-171">
                <img src="https://cdn.magicpatterns.com/uploads/igFPFWe6QurLv1Fq8d9zkK/logo_sans_texte.png" alt="ADCC - Symbole de croissance et d'accompagnement" className="w-full max-w-[300px] h-auto" data-id="element-172" />
              </div>
            </div>
            <div className="order-1 lg:order-2" data-id="element-173">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-174">
                Notre Histoire
              </h2>
              <div className="prose prose-lg text-gray-600" data-id="element-175">
                <p className="mb-4" data-id="element-176">
                  L'Association Dignité Compétence Création (ADCC) est née il y
                  a quelques mois au Bénin, animée par la détermination d'un
                  groupe de professionnels engagés à transformer le destin des
                  femmes, des jeunes et des travailleurs invisibles. Notre
                  mission ? Combattre la précarité en les autonomisant et en
                  facilitant leur insertion professionnelle durable.
                </p>
                <p className="mb-4" data-id="element-177">
                  Nos premiers pas ont été marqués par un forum d'état des
                  lieux, qui a réuni ces acteurs oubliés pour cartographier
                  leurs besoins et aspirations. Aujourd'hui, déjà reconnue,
                  l'ADCC accélère ses ambitions sur plusieurs fronts : formation
                  professionnelle adaptée, certification reconnue, placement en
                  emploi et suivi post-insertion. Avec votre confiance et votre
                  appui, nous amplifierons cet élan pour un impact national.
                </p>
                <p data-id="element-178">
                  Notre nom porte nos piliers : restaurer la{' '}
                  <strong data-id="element-179">Dignité</strong> humaine, forger les{' '}
                  <strong data-id="element-180">Compétences</strong> techniques et intellectuelles, et
                  libérer la <strong data-id="element-181">Création</strong> de valeur et
                  d'opportunités d'emplois pérennes. Ensemble, écrivons les
                  prochaines pages de cette aventure transformative !
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Values */}
      <section className="py-20 bg-gray-50" data-id="element-182">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-184">
            <Card className="text-center h-full" data-id="element-185">
              <CardContent className="pt-8" data-id="element-186">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-187">
                  <Target className="w-8 h-8 text-[#1E88E5]" data-id="element-188" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-189">
                  Notre Mission
                </h3>
                <p className="text-gray-600" data-id="element-190">
                  Accompagner les populations vulnérables vers l'autonomie
                  financière et sociale à travers des programmes de renforcement
                  de capacités adaptés, et un accompagnement à l'insertion
                  professionnelle durable.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center h-full" data-id="element-191">
              <CardContent className="pt-8" data-id="element-192">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-193">
                  <Eye className="w-8 h-8 text-[#1E88E5]" data-id="element-194" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-195">
                  Notre Vision
                </h3>
                <p className="text-gray-600" data-id="element-196">
                  Un Bénin où chaque individu, quel que soit son milieu
                  d'origine, a les moyens de construire sa vie avec dignité,
                  d'accéder à un emploi décent, et de contribuer au progrès de
                  sa communauté.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center h-full" data-id="element-197">
              <CardContent className="pt-8" data-id="element-198">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-199">
                  <Heart className="w-8 h-8 text-[#1E88E5]" data-id="element-200" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-201">
                  Nos Valeurs
                </h3>
                <ul className="text-gray-600 space-y-2" data-id="element-202">
                  <li data-id="element-203">Dignité et Respect</li>
                  <li data-id="element-204">Intégrité et Transparence</li>
                  <li data-id="element-205">Excellence et Innovation</li>
                  <li data-id="element-206">Insertion Durable</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>;
}